import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home pt-16 lg:pt-[6.5rem] flex flex-col gap-8 md:gap-12 mb-8" }
const _hoisted_2 = {
  class: "banners",
  id: "inicio"
}
const _hoisted_3 = {
  class: "swiper px-4 lg:px-8",
  ref: "banners"
}
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "overlay bg-gradient-to-t from-black to-transparent w-full h-1/3 absolute bottom-0 left-0" }, null, -1)
const _hoisted_6 = { class: "bannerText text-white text-center relative" }
const _hoisted_7 = { class: "text-3xl font-semibold uppercase mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "button py-2 px-4 border border-white w-fit mx-auto cursor-pointer hover:bg-white hover:bg-opacity-20" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Ver Productos")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev hidden md:flex" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next hidden md:flex" }, null, -1)
const _hoisted_11 = { class: "flex gap-2 md:gap-4 px-4 lg:px-8" }
const _hoisted_12 = {
  class: "px-4 md:px-8",
  id: "novedades"
}
const _hoisted_13 = {
  key: 0,
  id: "content"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  id: "sectionTitle",
  class: "mb-8 flex items-center justify-center"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "titleContainer",
    class: "w-fit flex flex-col items-center justify-center"
  }, [
    /*#__PURE__*/_createElementVNode("p", {
      id: "title",
      class: "font-semibold text-emerald-900 px-2 md:text-xl"
    }, "Novedades"),
    /*#__PURE__*/_createElementVNode("div", {
      id: "line",
      class: "w-full h-1 bg-emerald-900"
    })
  ])
], -1)
const _hoisted_15 = {
  id: "products",
  class: "grid grid-cols-3 gap-4 lg:grid-cols-6 mb-8"
}
const _hoisted_16 = {
  key: 1,
  id: "skeleton",
  class: "animate-pulse"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  id: "sectionTitle",
  class: "sectionTitle mb-8 flex items-center justify-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "title w-fit flex flex-col items-center justify-center" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "h-8 bg-gray-300 rounded-md w-32" })
  ])
], -1)
const _hoisted_18 = {
  id: "products",
  class: "grid grid-cols-3 gap-4 lg:grid-cols-6 mb-11"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "image bg-gray-300 aspect-square bg-center bg-cover rounded-md" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text py-2 flex flex-col gap-2 text-center font-bold" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "h-8 bg-gray-300 rounded-md" }),
  /*#__PURE__*/_createElementVNode("p", { class: "h-5 bg-gray-300 rounded-md" })
], -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "h-10 w-[200px] bg-gray-300 rounded-md mx-auto" }, null, -1)
const _hoisted_23 = { class: "sale" }
const _hoisted_24 = {
  class: "swiper px-4 lg:px-8",
  ref: "sale"
}
const _hoisted_25 = { class: "swiper-wrapper" }
const _hoisted_26 = { class: "banner w-full relative aspect-[4/1] md:aspect-[5/1] bg-gray-300 rounded-md overflow-hidden" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "text w-full h-full absolute top-0 left-0 flex flex-col items-center justify-center text-white text-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-3xl md:text-6xl font-semibold" }, "Ofertas", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm md:text-xl" }, [
  /*#__PURE__*/_createTextVNode("Descubre nuestras"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("promociones")
], -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev hidden md:flex" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next hidden md:flex" }, null, -1)
const _hoisted_34 = { class: "px-4 lg:px-8 animate-pulse" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  id: "bannerContainer",
  class: "w-full aspect-[4/1] md:aspect-[5/1] bg-gray-300 rounded-md"
}, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  class: "px-4 md:px-8",
  id: "electro"
}
const _hoisted_38 = {
  key: 0,
  id: "content"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  id: "sectionTitle",
  class: "mb-8 flex items-center justify-center"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "titleContainer",
    class: "w-fit flex flex-col items-center justify-center"
  }, [
    /*#__PURE__*/_createElementVNode("p", {
      id: "title",
      class: "font-semibold text-emerald-900 px-2 md:text-xl"
    }, "Interior"),
    /*#__PURE__*/_createElementVNode("div", {
      id: "line",
      class: "w-full h-1 bg-emerald-900"
    })
  ])
], -1)
const _hoisted_40 = {
  id: "products",
  class: "grid grid-cols-2 gap-4 lg:grid-cols-4"
}
const _hoisted_41 = {
  key: 1,
  id: "skeleton",
  class: "animate-pulse"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  id: "sectionTitle",
  class: "sectionTitle mb-8 flex items-center justify-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "title w-fit flex flex-col items-center justify-center" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "h-8 bg-gray-300 rounded-md w-32" })
  ])
], -1)
const _hoisted_43 = {
  id: "products",
  class: "grid grid-cols-2 gap-4 lg:grid-cols-4"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "image bg-gray-300 aspect-square bg-center bg-cover rounded-md" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "text py-2 flex flex-col gap-1 text-center font-bold" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "h-6 bg-gray-300 rounded-md" }),
  /*#__PURE__*/_createElementVNode("p", { class: "h-5 bg-gray-300 rounded-md" })
], -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  class: "px-4 md:px-8",
  id: "others"
}
const _hoisted_48 = {
  key: 0,
  id: "content"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", {
  id: "sectionTitle",
  class: "mb-8 flex items-center justify-center"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "titleContainer",
    class: "w-fit flex flex-col items-center justify-center"
  }, [
    /*#__PURE__*/_createElementVNode("p", {
      id: "title",
      class: "font-semibold text-emerald-900 px-2 md:text-xl"
    }, "Electrodomésticos"),
    /*#__PURE__*/_createElementVNode("div", {
      id: "line",
      class: "w-full h-1 bg-emerald-900"
    })
  ])
], -1)
const _hoisted_50 = {
  id: "products",
  class: "grid grid-cols-2 gap-4 lg:grid-cols-6"
}
const _hoisted_51 = {
  key: 1,
  id: "skeleton",
  class: "animate-pulse"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", {
  id: "sectionTitle",
  class: "sectionTitle mb-8 flex items-center justify-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "title w-fit flex flex-col items-center justify-center" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "h-8 bg-gray-300 rounded-md w-32" })
  ])
], -1)
const _hoisted_53 = {
  id: "products",
  class: "grid grid-cols-2 gap-4 lg:grid-cols-6"
}
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<div class=\"image bg-gray-300 aspect-square bg-center bg-cover rounded-md\"></div><div class=\"text py-2 flex flex-col gap-1 text-center font-bold\"><p class=\"h-6 bg-gray-300 rounded-md\"></p><p class=\"h-5 bg-gray-300 rounded-md\"></p><p class=\"h-5 bg-gray-300 rounded-md\"></p></div>", 2)
const _hoisted_56 = [
  _hoisted_54
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "swiper-slide",
              key: index
            }, [
              _createVNode(_component_router_link, {
                to: '/categoria/' + category.id
              }, {
                default: _withCtx(() => [
                  category
                    ? (_openBlock(), _createBlock(_component_Banner, {
                        key: 0,
                        class: "flex items-end justify-center p-8 relative cursor-pointer",
                        image: category.image.data.thumbnails[5].url
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5,
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("p", _hoisted_7, _toDisplayString(category.name), 1),
                            _hoisted_8
                          ])
                        ]),
                        _: 2
                      }, 1032, ["image"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _hoisted_9,
        _hoisted_10
      ], 512), [
        [_vShow, !_ctx.loading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
          return _createElementVNode("div", {
            id: "bannerContainer",
            class: "w-full md:w-[calc(33%-6px)] flex-none",
            key: i
          }, [
            _createVNode(_component_Banner)
          ])
        }), 64))
      ], 512), [
        [_vShow, _ctx.loading]
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      (_ctx.latest.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latest, (product, index) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  to: '/producto/' + product.id,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ProductCard, {
                      name: product.name,
                      price: product.price,
                      image: (product.gallery[0].directus_files_id.data.thumbnails) ? product.gallery[0].directus_files_id.data.thumbnails[2].url : null
                    }, null, 8, ["name", "price", "image"])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]),
            _createVNode(_component_router_link, { to: "/novedades" }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, { class: "w-[200px] bg-emerald-900 text-white mx-auto" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ver Todas")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
                return _createElementVNode("div", {
                  class: "productCard overflow-hidden",
                  key: index
                }, _hoisted_21)
              }), 64))
            ]),
            _hoisted_22
          ]))
    ]),
    _createElementVNode("section", _hoisted_23, [
      _withDirectives(_createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saleBanners, (banner, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "swiper-slide",
              key: index
            }, [
              _createVNode(_component_router_link, {
                to: banner.link
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("img", {
                      class: "w-full h-full object-cover",
                      src: (banner) ? banner.image.data.full_url : '/img/ofertas.jpeg'
                    }, null, 8, _hoisted_27),
                    _withDirectives(_createElementVNode("div", _hoisted_28, _hoisted_31, 512), [
                      [_vShow, !_ctx.saleBanners]
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _hoisted_32,
        _hoisted_33
      ], 512), [
        [_vShow, !_ctx.loading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_34, _hoisted_36, 512), [
        [_vShow, _ctx.loading]
      ])
    ]),
    _createElementVNode("section", _hoisted_37, [
      (_ctx.indoor.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indoor, (product, index) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  to: '/producto/' + product.id,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ProductCard, {
                      name: product.name,
                      price: product.price,
                      image: product.gallery[0].directus_files_id.data.thumbnails[2].url
                    }, null, 8, ["name", "price", "image"])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                return _createElementVNode("div", {
                  class: "productCard overflow-hidden",
                  key: index
                }, _hoisted_46)
              }), 64))
            ])
          ]))
    ]),
    _createElementVNode("section", _hoisted_47, [
      (_ctx.outdoor.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outdoor, (product, index) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  to: '/producto/' + product.id,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ProductCard, {
                      name: product.name,
                      price: product.price,
                      image: product.gallery[0].directus_files_id.data.thumbnails[2].url
                    }, null, 8, ["name", "price", "image"])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
                return _createElementVNode("div", {
                  class: "productCard overflow-hidden",
                  key: index
                }, _hoisted_56)
              }), 64))
            ])
          ]))
    ])
  ]))
}